import { Inject, Injectable, Optional } from '@angular/core';
import { DashboardCard, DashboardCardService, SalesSummaryCardComponent } from 'gung-dashboard';
import { AuthService, NavigationConfig } from 'gung-standard';
import { filter } from 'rxjs';
import { CarLinerSalesSummaryCardComponent } from '../components/car-liner-sales-summary-card/car-liner-sales-summary-card.component';

@Injectable({
  providedIn: 'root'
})
export class CarLinerDashboardCardService extends DashboardCardService{

  private DEFAULT_COLUMN_SIZE = 'col-xs-12 col-md-12 col-xl-12';
  
  constructor(
    protected authService: AuthService,
    @Optional()
    @Inject('environment')
    protected environment: NavigationConfig) {
    super(authService,environment);
    this.getCards()
      .pipe(filter(cards => cards.length > 0))
      .subscribe(cards => {
        cards.find(card => {
          if (card.component === SalesSummaryCardComponent) {
            this.removeCard(card);

            this.addCard(new DashboardCard(CarLinerSalesSummaryCardComponent, this.DEFAULT_COLUMN_SIZE));
          }
        });
      });
  }
}
